export default __webpack_public_path__ + "c19f636636be24f0eb953c52a041b67c.svg";